import {
  isSupportedCompareDataDTO as isSupportedCompareDataDTOLatest,
  version,
} from './compare-data-v2';
import { upgrade } from './compare-data-v2.upgrade';

export type CompareDataDTOLatest = ReturnType<typeof upgrade>;
export type CompareDataDTOLatestInput = Parameters<typeof upgrade>[0];

export const isSupportedCompareDataDTO = isSupportedCompareDataDTOLatest;

export function isCompareDataDTOLatest(
  input: CompareDataDTOLatestInput,
): input is CompareDataDTOLatest {
  return input.version === version;
}

export const upgradeToCompareDataDTOLatest = upgrade;

export function wrapAsCompareDataDTOLatest(
  data: Omit<CompareDataDTOLatest, 'version'>,
): CompareDataDTOLatest {
  return { version, ...data };
}
